import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import TransferHistoryFormPresenter from "./TransferHistoryFormPresenter";

class TransferHistoryFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, selectedRawIds: [] };
    this.presenter = new TransferHistoryFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "stock_transfers";
  }

  render() {
    const object = this.state.object;
    console.log("object", object);
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label =
      this.getObjectId() === undefined ? "Add " : "View Transfer Logs ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h2
                  className="fw-bold mt-3 text-capitalize"
                  style={{ color: "#82c14a" }}
                >
                  <i
                    onClick={() => this.navigateBack()}
                    className="bi bi-chevron-compact-left"
                    style={{ color: "black", cursor: "pointer" }}
                  ></i>
                  {
                    label
                    // (schema.label || toDisplayCase(this.getCollectionName()))
                  }
                </h2>

                {object?.id && (
                  <span
                    className="px-3 py-1 fw-semibold"
                    style={{
                      backgroundColor: "#ffcd29", // yellow
                      borderRadius: "999px",
                      color: "#212529", // dark text
                      fontSize: "0.875rem",
                      border: "1px solid #d6a500",
                    }}
                  >
                    Current Status: {object?.status}
                  </span>
                )}
              </div>

              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                {object?.logsArray?.length > 0 && (
                  <div className="mt-4">
                    <h5 className="text-primary fw-bold mb-3">Status Update</h5>
                    <div className="border rounded px-4 py-3 bg-white">
                      {object.logsArray
                        .slice() // shallow copy
                        .reverse() // show latest on top
                        .map((log, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-2"
                          >
                            <span
                              className=""
                              style={{ color: "#6c757d", fontSize: "0.9rem" }}
                            >
                              {log?.timestamp &&
                                new Date(log?.timestamp).toLocaleString(
                                  "en-US",
                                  {
                                    month: "long", // March
                                    day: "numeric", // 2
                                    year: "numeric", // 2025
                                    hour: "numeric", // 5
                                    minute: "2-digit", // 15
                                    hour12: true, // am/pm
                                  }
                                )}
                            </span>
                            <span
                              className="fw-bold"
                              style={{
                                color:
                                  log.status === "Done"
                                    ? "green"
                                    : log.status === "For Dispatch"
                                    ? "orange"
                                    : log.status === "Cancelled"
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {log.status}
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(TransferHistoryFormPage);
